export default "__VITE_ASSET__BGHATiku__"